/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames';
import { ButtonHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.scss';

export interface IContextMenuItemProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  text: string;
  icon: React.ReactNode;
  onClick: () => void;
}

const ContextMenuItem = forwardRef<HTMLButtonElement, IContextMenuItemProps>(
  ({ text, icon, onClick, className, ...rest }, ref) => {
    return (
      <button
        {...rest}
        ref={ref}
        aria-label={text}
        onClick={onClick}
        className={classNames(styles.contextMenuItem, className)}
        role='menuitem'
      >
        <div className={styles.icon}>{icon}</div>
        <div className={styles.text}>{text}</div>
      </button>
    );
  },
);

ContextMenuItem.displayName = 'ContextMenuItem';

export default ContextMenuItem;
